(function () {
  'use strict';

  if (window._bpRacketLoaded) return;
  window._bpRacketLoaded = true;

  // ── Config from pre-rendered JSON ───────────────────────────────────────
  var config = {};
  try {
    var cfgEl = document.getElementById('bps-config');
    if (cfgEl) config = JSON.parse(cfgEl.textContent);
  } catch (e) { config = {}; }

  if (!config.racketVariantId) {
    var variantInput = document.getElementById('bph-variant-id');
    var fallbackVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (fallbackVariantId) config.racketVariantId = fallbackVariantId;
  }

  // ── Helpers ─────────────────────────────────────────────────────────────
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function set(id, txt)  { var el = document.getElementById(id); if (el) el.textContent = txt; }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  function escHtml(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── State ───────────────────────────────────────────────────────────────
  var strings = config.strings || [];
  var state = {
    mode:              'strung',
    step:              'setup',
    fullStr:           null,
    fullStrVariant:    null,
    mainsStr:          null,
    mainsStrVariant:   null,
    crossesStr:        null,
    crossesStrVariant: null,
    mainsTension:      '',
    crossesTension:    '',
    stringSaver:       false,
    adding:            false,
    racketAvailable:   config.racketAvailable === true,
    variants:          [],
  };

  // ── Bootstrap ────────────────────────────────────────────────────────────
  var initialized = false;

  function init() {
    if (initialized) return;
    initialized = true;

    loadVariants();
    initVariantAvailability();
    initRacketToggle();
    initModal();
    initAccordion();
    initPickers();
    initTensionInputs();
    initStringSaver();
    initAddButtons();
    watchVariantChange();
    updateAtcArea();
    updatePrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Variants (for price sync when grip/size changes) ─────────────────────
  function loadVariants() {
    var el = qs('[data-variant-json]');
    if (!el) return;
    try { state.variants = JSON.parse(el.textContent); } catch (e) {}
  }

  function getCurrentVariantPrice() {
    var input = document.getElementById('bph-variant-id');
    if (!input || !state.variants.length) return config.racketPrice || 0;
    var vid = parseInt(input.value, 10);
    var v = state.variants.find(function (v) { return v.id === vid; });
    return v ? v.price : (config.racketPrice || 0);
  }

  function getCurrentRacketVariant() {
    var input = document.getElementById('bph-variant-id');
    if (!input || !state.variants.length) return null;
    var variantId = parseInt(input.value, 10);
    return state.variants.find(function (variant) { return Number(variant.id) === variantId; }) || null;
  }

  function setRacketAvailability(variant) {
    var available = Boolean(variant && variant.available);
    state.racketAvailable = available;

    var controls = document.getElementById('bph-purchase-controls');
    if (controls) {
      controls.disabled = !available;
      controls.hidden = !available;
      controls.classList.toggle('is-unavailable', !available);
    }

    qsa('[data-bph-available-only]').forEach(function (element) {
      element.hidden = !available;
    });

    var soldOut = document.getElementById('bph-sold-out');
    if (soldOut) soldOut.hidden = available;

    qsa('.bps__add-btn').forEach(function (button) {
      button.disabled = !available;
    });

    if (!available && modal && modal.classList.contains('is-open')) closeModal();
    updateAtcArea();
  }

  function initVariantAvailability() {
    var form = qs('.bph__form');
    if (form) {
      form.addEventListener('bp:variant-change', function (event) {
        setRacketAvailability(event.detail && event.detail.variant);
      });
    }

    var initialVariant = getCurrentRacketVariant();
    setRacketAvailability(initialVariant || {
      id: config.racketVariantId,
      available: config.racketAvailable === true,
    });
  }

  function watchVariantChange() {
    var priceEl = document.getElementById('bph-price');
    if (!priceEl) return;
    new MutationObserver(function () { updatePrices(); })
      .observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  // ── Racket toggle ────────────────────────────────────────────────────────
  function initRacketToggle() {
    qsa('[data-racket-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.dataset.racketBtn;
        qsa('[data-racket-btn]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        updateAtcArea();
      });
    });
  }

  function updateAtcArea() {
    var atc     = document.getElementById('bph-atc');
    var cfgBtn  = document.getElementById('bps-configure-btn');
    var note    = document.getElementById('bps-stringing-note');

    var isStrung = state.mode === 'strung';
    if (atc) {
      atc.style.display = !state.racketAvailable || isStrung ? 'none' : '';
      atc.disabled = !state.racketAvailable;
      atc.textContent = state.racketAvailable ? 'Add to cart' : 'Sold out';
    }
    if (cfgBtn) {
      cfgBtn.style.display = !state.racketAvailable || isStrung ? '' : 'none';
      cfgBtn.disabled = !state.racketAvailable;
      cfgBtn.textContent = state.racketAvailable
        ? (cfgBtn.dataset.availableLabel || 'Configure stringing →')
        : (cfgBtn.dataset.soldOutLabel || 'Sold out');
    }
    if (note) note.hidden = !state.racketAvailable || !isStrung;
  }

  // ── Modal open / close ───────────────────────────────────────────────────
  var backdrop = document.getElementById('bps-backdrop');
  var modal    = document.getElementById('bps-modal');

  function refreshModalRefs() {
    backdrop = document.getElementById('bps-backdrop');
    modal = document.getElementById('bps-modal');
  }

  function initModal() {
    refreshModalRefs();
    if (!backdrop || !modal) return;

    var cfgBtn = document.getElementById('bps-configure-btn');
    if (cfgBtn) cfgBtn.addEventListener('click', openModal);

    backdrop.addEventListener('click', closeModal);

    var closeBtn = document.getElementById('bps-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    qsa('[data-setup]').forEach(function (btn) {
      btn.addEventListener('click', function () { showStep(btn.dataset.setup); });
    });

    qsa('[data-bps-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { showStep('setup'); });
    });
  }

  function openModal() {
    if (!state.racketAvailable) return;
    refreshModalRefs();
    if (!backdrop || !modal) return;
    backdrop.classList.add('is-open');
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    showStep('setup');
    setTimeout(function () {
      var f = qs('button, [tabindex="0"]', modal);
      if (f) f.focus();
    }, 100);
  }

  function closeModal() {
    refreshModalRefs();
    if (!backdrop || !modal) return;
    backdrop.classList.remove('is-open');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function showStep(step) {
    refreshModalRefs();
    if (!modal) return;
    state.step = step;
    qsa('[data-bps-step]', modal).forEach(function (el) {
      el.hidden = el.dataset.bpsStep !== step;
    });
    // Reset accordions in the newly visible step to their intended default state:
    // setup → open; fullset/hybrid → closed
    var stepEl = qs('[data-bps-step="' + step + '"]', modal);
    if (stepEl) {
      var shouldOpen = step === 'setup';
      qsa('.bps__accordion-trigger', stepEl).forEach(function (trigger) {
        // Sub-accordions below the ATC button are always closed
        var isBelow = trigger.closest('.bps__accordion--below-atc');
        var open = shouldOpen && !isBelow;
        trigger.setAttribute('aria-expanded', String(open));
        var body = trigger.nextElementSibling;
        if (body) body.hidden = !open;
      });
    }
    var body = qs('.bps__body', modal);
    if (body) body.scrollTop = 0;
    updatePrices();
  }

  // ── Accordion ────────────────────────────────────────────────────────────
  function initAccordion() {
    qsa('.bps__accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        var body = trigger.nextElementSibling;
        if (body) body.hidden = expanded;
      });
    });
  }

  // ── String pickers ───────────────────────────────────────────────────────
  function initPickers() {
    qsa('.bps__picker').forEach(buildPicker);

    document.addEventListener('click', function () {
      qsa('.bps__picker').forEach(function (p) { closeDropdown(p); });
    });
  }

  function buildPicker(picker) {
    var dropdown = qs('.bps__picker-dropdown', picker);
    var selected = qs('.bps__picker-selected', picker);
    if (!dropdown || !selected) return;

    // Search input — fixed at top of dropdown, above scrollable panels
    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'bps__picker-search';
    searchInput.placeholder = 'Search strings…';
    searchInput.setAttribute('autocomplete', 'off');
    searchInput.setAttribute('autocorrect', 'off');
    searchInput.setAttribute('spellcheck', 'false');
    searchInput.addEventListener('click', function (e) { e.stopPropagation(); });
    dropdown.appendChild(searchInput);

    var productsPanel = document.createElement('div');
    productsPanel.className = 'bps__picker-products';

    var variantsPanel = document.createElement('div');
    variantsPanel.className = 'bps__picker-variants';
    variantsPanel.hidden = true;

    var noResults = document.createElement('p');
    noResults.className = 'bps__picker-no-results';
    noResults.textContent = 'No strings found.';
    noResults.hidden = true;

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.toLowerCase().trim();
      var anyVisible = false;
      qsa('.bps__picker-option', productsPanel).forEach(function (opt) {
        var name = opt.querySelector('.bps__picker-opt-name');
        var nameMatch = name && name.textContent.toLowerCase().indexOf(q) !== -1;
        var tagMatch  = opt.dataset.tags && opt.dataset.tags.indexOf(q) !== -1;
        var match = !q || nameMatch || tagMatch;
        opt.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
      });
      noResults.hidden = anyVisible || !q;
    });

    if (strings.length) {
      strings.forEach(function (product, idx) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'bps__picker-option';
        opt.dataset.productIdx = idx;
        opt.dataset.tags = (product.tags || []).join(',').toLowerCase();
        var HIDDEN_TAGS = ['hide-online-store', 'string', 'services', 'labor'];
        var visibleTags = (product.tags || []).filter(function (t) {
          return HIDDEN_TAGS.indexOf(t.toLowerCase()) === -1;
        });
        var tagsHtml = '';
        if (visibleTags.length) {
          tagsHtml = '<div class="bps__picker-opt-tags">' +
            visibleTags.map(function (t) {
              return '<span class="bps__picker-opt-tag">' + escHtml(t) + '</span>';
            }).join('') +
          '</div>';
        }
        opt.innerHTML =
          '<div class="bps__picker-opt-img">' +
            (product.image ? '<img src="' + escHtml(product.image) + '" alt="' + escHtml(product.title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="bps__picker-opt-info">' +
            '<span class="bps__picker-opt-name">' + escHtml(product.title) + '</span>' +
            tagsHtml +
            '<span class="bps__picker-opt-price">' + formatMoney(product.price) + '</span>' +
          '</div>' +
          '<svg class="bps__picker-opt-chevron" width="8" height="12" viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><polyline points="1,1 7,6 1,11"/></svg>';
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          showVariantsPanel(picker, product, productsPanel, variantsPanel, searchInput);
        });
        productsPanel.appendChild(opt);
      });
      productsPanel.appendChild(noResults);
    } else {
      productsPanel.innerHTML = '<div style="padding:14px;font-family:Inter,sans-serif;font-size:12px;color:#6b6b6b">No strings found in ' + escHtml(config.stringsCollectionTitle || 'the selected collection') + '.</div>';
    }

    dropdown.appendChild(productsPanel);
    dropdown.appendChild(variantsPanel);

    selected.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = picker.classList.contains('is-open');
      qsa('.bps__picker').forEach(closeDropdown);
      if (!isOpen) openDropdown(picker);
    });
  }

  function showVariantsPanel(picker, product, productsPanel, variantsPanel, searchInput) {
    var availableVariants = (product.variants || []).filter(function (v) { return v.available; });

    // Single available variant — select directly without showing the variants panel
    if (availableVariants.length === 1) {
      selectStringVariant(picker, product, availableVariants[0]);
      closeDropdown(picker);
      return;
    }

    variantsPanel.innerHTML = '';

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'bps__picker-variants-back';
    backBtn.textContent = '← Back';
    backBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      variantsPanel.hidden = true;
      productsPanel.hidden = false;
      if (searchInput) { searchInput.hidden = false; searchInput.focus(); }
    });
    variantsPanel.appendChild(backBtn);

    var productName = document.createElement('p');
    productName.className = 'bps__picker-variants-product-name';
    productName.textContent = product.title;
    variantsPanel.appendChild(productName);

    var optionsWrap = document.createElement('div');
    optionsWrap.className = 'bps__picker-variants-options';

    var currentVariant = null;
    var id = picker.id;
    if (id === 'bps-picker-full'    && state.fullStr    && state.fullStr.id    === product.id) currentVariant = state.fullStrVariant;
    if (id === 'bps-picker-mains'   && state.mainsStr   && state.mainsStr.id   === product.id) currentVariant = state.mainsStrVariant;
    if (id === 'bps-picker-crosses' && state.crossesStr && state.crossesStr.id === product.id) currentVariant = state.crossesStrVariant;

    availableVariants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bps__picker-variant-btn' + (currentVariant && currentVariant.id === variant.id ? ' is-selected' : '');
      btn.textContent = variant.title === 'Default Title' ? product.title : variant.title;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectStringVariant(picker, product, variant);
        closeDropdown(picker);
      });
      optionsWrap.appendChild(btn);
    });

    variantsPanel.appendChild(optionsWrap);

    productsPanel.hidden = true;
    variantsPanel.hidden = false;
    if (searchInput) searchInput.hidden = true;
  }

  function openDropdown(picker) {
    picker.classList.add('is-open');
    var d = qs('.bps__picker-dropdown', picker);
    if (d) {
      d.hidden = false;
      var productsPanel = qs('.bps__picker-products', d);
      var variantsPanel = qs('.bps__picker-variants', d);
      var searchEl      = qs('.bps__picker-search', d);
      if (productsPanel) productsPanel.hidden = false;
      if (variantsPanel) variantsPanel.hidden = true;
      if (searchEl) {
        searchEl.hidden = false;
        searchEl.value  = '';
        qsa('.bps__picker-option', d).forEach(function (opt) { opt.style.display = ''; });
        var noRes = qs('.bps__picker-no-results', d);
        if (noRes) noRes.hidden = true;
        setTimeout(function () { searchEl.focus(); }, 50);
      }
    }
  }

  function closeDropdown(picker) {
    picker.classList.remove('is-open');
    var d = qs('.bps__picker-dropdown', picker);
    if (d) d.hidden = true;
  }

  function selectStringVariant(picker, product, variant) {
    var nameEl  = qs('.bps__picker-name', picker);
    var priceEl = qs('.bps__picker-price', picker);
    var imgWrap = qs('.bps__picker-img-wrap', picker);

    if (imgWrap && product.image) {
      var img = imgWrap.querySelector('img');
      if (!img) { img = document.createElement('img'); img.alt = product.title; imgWrap.appendChild(img); }
      img.src = product.image;
    }

    var displayName = product.title;
    if (variant.title && variant.title !== 'Default Title') {
      displayName += ' · ' + variant.title;
    }

    if (nameEl)  nameEl.textContent  = displayName;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var id = picker.id;
    if (id === 'bps-picker-full') {
      state.fullStr = product;
      state.fullStrVariant = variant;
    }
    if (id === 'bps-picker-mains') {
      state.mainsStr = product;
      state.mainsStrVariant = variant;
    }
    if (id === 'bps-picker-crosses') {
      state.crossesStr = product;
      state.crossesStrVariant = variant;
    }

    updatePrices();
  }

  // ── Tension inputs ───────────────────────────────────────────────────────
  function initTensionInputs() {
    [
      ['bps-mains-tension-full',     function (v) { state.mainsTension   = v; }],
      ['bps-crosses-tension-full',   function (v) { state.crossesTension = v; }],
      ['bps-mains-tension-hybrid',   function (v) { state.mainsTension   = v; }],
      ['bps-crosses-tension-hybrid', function (v) { state.crossesTension = v; }],
    ].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (el) el.addEventListener('input', function () { pair[1](el.value); });
    });
  }

  function initStringSaver() {
    qsa('[data-string-saver]').forEach(function (input) {
      input.addEventListener('change', function () {
        state.stringSaver = input.checked;
        qsa('[data-string-saver]').forEach(function (other) {
          other.checked = state.stringSaver;
        });
        updatePrices();
      });
    });
  }

  // ── Price display ────────────────────────────────────────────────────────
  function getTensionInputs(setup) {
    var suffix = setup === 'fullset' ? 'full' : 'hybrid';
    return {
      mains:   document.getElementById('bps-mains-tension-'   + suffix),
      crosses: document.getElementById('bps-crosses-tension-' + suffix),
    };
  }

  function validateTensions(setup) {
    if (setup === 'fullset' && !state.fullStrVariant) {
      alert('Please select a string before adding to cart.');
      return false;
    }
    if (setup === 'hybrid' && (!state.mainsStrVariant || !state.crossesStrVariant)) {
      alert('Please select both mains and crosses strings before adding to cart.');
      return false;
    }

    var inputs = getTensionInputs(setup);
    var minTension = Number.isFinite(Number(config.tensionMin)) ? Number(config.tensionMin) : 40;
    var maxTension = Number.isFinite(Number(config.tensionMax)) ? Number(config.tensionMax) : 70;
    var missing = [];

    if (!inputs.mains   || !inputs.mains.value.trim())   missing.push('mains');
    if (!inputs.crosses || !inputs.crosses.value.trim()) missing.push('crosses');

    if (missing.length) {
      alert('Please choose mains and crosses tension before adding the strung racket to cart.');
      var target = missing[0] === 'mains' ? inputs.mains : inputs.crosses;
      if (target) target.focus();
      return false;
    }

    var mainsValue   = Number(inputs.mains.value);
    var crossesValue = Number(inputs.crosses.value);

    if (!Number.isFinite(mainsValue) || mainsValue < minTension || mainsValue > maxTension) {
      alert('Mains tension must be a number between ' + minTension + ' and ' + maxTension + ' lbs.');
      inputs.mains.focus();
      return false;
    }

    if (!Number.isFinite(crossesValue) || crossesValue < minTension || crossesValue > maxTension) {
      alert('Crosses tension must be a number between ' + minTension + ' and ' + maxTension + ' lbs.');
      inputs.crosses.focus();
      return false;
    }

    if (!inputs.mains.checkValidity())   { inputs.mains.reportValidity();   return false; }
    if (!inputs.crosses.checkValidity()) { inputs.crosses.reportValidity(); return false; }

    state.mainsTension   = String(mainsValue);
    state.crossesTension = String(crossesValue);
    return true;
  }

  function updatePrices() {
    var racket = getCurrentVariantPrice();

    // Full Set — string is added ×2 (mains + crosses)
    var fullStrUnit  = state.fullStrVariant ? state.fullStrVariant.price : 0;
    var fullStrPrice = fullStrUnit * 2;
    var stringSaverPrice = state.stringSaver ? (config.stringSaverPrice || 0) : 0;
    var fullTot      = racket + fullStrPrice + stringSaverPrice;
    var fullLbl      = 'String ×2 + included labor' + (state.fullStr ? ' (' + variantLabel(state.fullStr, state.fullStrVariant) + ')' : '');

    set('bps-racket-price-full',  formatMoney(racket));
    set('bps-service-label-full', fullLbl);
    set('bps-service-price-full', '+' + formatMoney(fullStrPrice));
    var fullSaverRow = document.getElementById('bps-string-saver-row-full');
    if (fullSaverRow) fullSaverRow.style.display = state.stringSaver ? '' : 'none';
    set('bps-string-saver-price-full', state.stringSaver ? '+' + formatMoney(stringSaverPrice) : '');
    set('bps-total-full',         formatMoney(fullTot));

    // Hybrid
    var mainsP   = state.mainsStrVariant   ? state.mainsStrVariant.price   : 0;
    var crossesP = state.crossesStrVariant ? state.crossesStrVariant.price : 0;
    var hybridLbl = 'Strings + included labor';
    if (state.mainsStr || state.crossesStr) {
      var parts = [
        state.mainsStr   ? variantLabel(state.mainsStr,   state.mainsStrVariant)   : '',
        state.crossesStr ? variantLabel(state.crossesStr, state.crossesStrVariant) : '',
      ].filter(Boolean);
      hybridLbl += ' (' + parts.join(' - ') + ')';
    }
    var hybridTot = racket + mainsP + crossesP;

    var vsFee    = shouldApplyVsHybridFee() ? (config.vsHybridFeePrice || 0) : 0;
    var vsFeeRow = document.getElementById('bps-vs-fee-row');
    if (vsFeeRow) vsFeeRow.style.display = vsFee ? '' : 'none';
    set('bps-vs-fee-price', vsFee ? '+' + formatMoney(vsFee) : '');
    hybridTot += vsFee;
    hybridTot += stringSaverPrice;

    set('bps-racket-price-hybrid',  formatMoney(racket));
    set('bps-service-label-hybrid', hybridLbl);
    set('bps-service-price-hybrid', '+' + formatMoney(mainsP + crossesP));
    var hybridSaverRow = document.getElementById('bps-string-saver-row-hybrid');
    if (hybridSaverRow) hybridSaverRow.style.display = state.stringSaver ? '' : 'none';
    set('bps-string-saver-price-hybrid', state.stringSaver ? '+' + formatMoney(stringSaverPrice) : '');
    set('bps-total-hybrid',         formatMoney(hybridTot));
  }

  // ── VS Hybrid Fee logic ──────────────────────────────────────────────────
  // Accept both hyphenated (natural-gut) and space-separated (natural gut) forms
  var NATURAL_GUT_TAGS = ['natural-gut', 'natural gut'];
  var VS_FEE_TAGS      = ['synthetic-gut', 'synthetic gut', 'polyester', 'multifilament'];

  function hasTag(product, tag) {
    if (!product || !product.tags) return false;
    var lower = tag.toLowerCase();
    return product.tags.some(function (t) { return t.toLowerCase() === lower; });
  }

  function hasAnyTag(product, tags) {
    return tags.some(function (tag) { return hasTag(product, tag); });
  }

  function shouldApplyVsHybridFee() {
    if (!config.vsHybridFeeVariantId) return false;
    if (!state.mainsStr || !state.crossesStr) return false;
    var mainsIsNatGut   = hasAnyTag(state.mainsStr,   NATURAL_GUT_TAGS);
    var crossesIsNatGut = hasAnyTag(state.crossesStr, NATURAL_GUT_TAGS);
    // Both natural gut → no fee; neither → no fee
    if (mainsIsNatGut === crossesIsNatGut) return false;
    var other = mainsIsNatGut ? state.crossesStr : state.mainsStr;
    return hasAnyTag(other, VS_FEE_TAGS);
  }

  // ── Add to cart ──────────────────────────────────────────────────────────
  function initAddButtons() {
    var addFull   = document.getElementById('bps-add-fullset');
    var addHybrid = document.getElementById('bps-add-hybrid');
    if (addFull)   addFull.addEventListener('click',   function () { doAdd('fullset'); });
    if (addHybrid) addHybrid.addEventListener('click', function () { doAdd('hybrid'); });
  }

  function variantLabel(product, variant) {
    if (!variant || !variant.title || variant.title === 'Default Title') return product ? product.title : '';
    return (product ? product.title + ' · ' : '') + variant.title;
  }

  function doAdd(setup) {
    if (state.adding) return;
    var racketVariant = getCurrentRacketVariant();
    if (!state.racketAvailable || !racketVariant || !racketVariant.available) {
      setRacketAvailability(racketVariant);
      return;
    }
    if (!validateTensions(setup)) return;

    state.adding = true;

    var btnId = setup === 'fullset' ? 'bps-add-fullset' : 'bps-add-hybrid';
    var btn = document.getElementById(btnId);
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    var vid     = parseInt((document.getElementById('bph-variant-id') || {}).value, 10) || config.racketVariantId;
    var qty     = parseInt((qs('.bph__qty-val') || {}).textContent, 10) || 1;
    var groupId = Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
    var props   = {};

    if (setup === 'fullset') {
      props['Setup']           = 'Full Set';
      props['String']          = variantLabel(state.fullStr, state.fullStrVariant);
      if (state.mainsTension)   props['Mains Tension']   = state.mainsTension   + ' lbs';
      if (state.crossesTension) props['Crosses Tension'] = state.crossesTension + ' lbs';
    } else {
      props['Setup']           = 'Hybrid';
      props['Mains String']    = variantLabel(state.mainsStr,   state.mainsStrVariant);
      props['Crosses String']  = variantLabel(state.crossesStr, state.crossesStrVariant);
      if (state.mainsTension)   props['Mains Tension']   = state.mainsTension   + ' lbs';
      if (state.crossesTension) props['Crosses Tension'] = state.crossesTension + ' lbs';
    }

    props['_Stringing group'] = groupId;
    if (state.stringSaver && config.stringSaverVariantId) {
      props['String Savers'] = config.stringSaverTitle || 'Added';
    }
    var items = [{ id: vid, quantity: qty, properties: props }];

    function addStringItem(product, variant, role) {
      if (!variant || !variant.id) return;

      var existing = items.find(function (item) {
        return item.id === variant.id && item.properties && item.properties['_Stringing role'] === role;
      });

      if (existing) { existing.quantity += qty; return; }

      items.push({
        id: variant.id,
        quantity: qty,
        properties: {
          '_Stringing item':  'Yes',
          '_Stringing group': groupId,
          '_Stringing setup': setup === 'fullset' ? 'Full Set' : 'Hybrid',
          '_Stringing role':  role,
        },
      });
    }

    if (setup === 'fullset') {
      // Full set uses the same string for mains and crosses — add x2
      if (state.fullStrVariant && state.fullStrVariant.id) {
        items.push({
          id: state.fullStrVariant.id,
          quantity: qty * 2,
          properties: {
            '_Stringing item':  'Yes',
            '_Stringing group': groupId,
            '_Stringing setup': 'Full Set',
            '_Stringing role':  'String',
          },
        });
      }
    } else {
      addStringItem(state.mainsStr,   state.mainsStrVariant,   'Mains');
      addStringItem(state.crossesStr, state.crossesStrVariant, 'Crosses');

      if (shouldApplyVsHybridFee() && config.vsHybridFeeVariantId) {
        items.push({
          id: config.vsHybridFeeVariantId,
          quantity: qty,
          properties: {
            '_Stringing item':  'Yes',
            '_Stringing group': groupId,
            '_Stringing setup': 'Hybrid',
            '_Stringing role':  'VS Hybrid Fee',
          },
        });
      }
    }

    if (config.serviceVariantId && Number(config.servicePrice || 0) === 0) {
      items.push({
        id: config.serviceVariantId,
        quantity: qty,
        properties: {
          '_Stringing item':  'Yes',
          '_Stringing group': groupId,
          '_Stringing role':  'Included labor',
          '_Stringing setup': setup === 'fullset' ? 'Full Set' : 'Hybrid',
        },
      });
    }

    if (state.stringSaver && config.stringSaverVariantId) {
      items.push({
        id: config.stringSaverVariantId,
        quantity: qty,
        properties: {
          '_Stringing item':  'Yes',
          '_Stringing group': groupId,
          '_Stringing role':  'String Savers',
          '_Stringing setup': setup === 'fullset' ? 'Full Set' : 'Hybrid',
        },
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var errorMessage = data.description || data.message || 'Could not add to cart.';
          var inventoryError = /sold out|out of stock|inventory|not enough|only .* available|can(?:not|'t) add more|unable to add item/i.test(errorMessage);
          if (inventoryError) {
            setRacketAvailability({ id: vid, available: false });
          }
          alert(errorMessage);
          state.adding = false;
          if (btn) {
            btn.textContent = state.racketAvailable ? origText : 'Sold out';
            btn.disabled = !state.racketAvailable;
          }
        } else {
          state.adding = false;
          if (btn) { btn.textContent = origText; btn.disabled = false; }
          closeModal();
          document.dispatchEvent(new CustomEvent('bp:cart:refresh'));
          document.dispatchEvent(new CustomEvent('bp:cart:open'));
        }
      })
      .catch(function () {
        alert('Could not add to cart. Please try again.');
        state.adding = false;
        if (btn) {
          btn.textContent = state.racketAvailable ? origText : 'Sold out';
          btn.disabled = !state.racketAvailable;
        }
      });
  }

})();
